"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.serverShow = serverShow;
exports.clientShow = clientShow;
exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _reactDom = babelHelpers.interopRequireDefault(require("react-dom"));

var _decorators = require("decorators");

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _temp, _class3, _descriptor8, _temp2;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var OrderHistory = (_class3 = (_temp2 =
/*#__PURE__*/
function (_Component2) {
  babelHelpers.inherits(OrderHistory, _Component2);

  function OrderHistory() {
    var _babelHelpers$getProt2;

    var _this3;

    babelHelpers.classCallCheck(this, OrderHistory);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this3 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt2 = babelHelpers.getPrototypeOf(OrderHistory)).call.apply(_babelHelpers$getProt2, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this3, "orderList", _descriptor8, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    return _this3;
  }

  babelHelpers.createClass(OrderHistory, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "card-container card-list"
      }, this.orderList.map(function (order) {
        return _react.default.createElement(OrderLine, _extends({
          key: order.id
        }, order));
      }));
    }
  }]);
  return OrderHistory;
}(_react.Component), _temp2), (_descriptor8 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "orderList", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
})), _class3);
exports.default = OrderHistory;
var OrderLine = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(OrderLine, _Component);

  function OrderLine() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, OrderLine);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(OrderLine)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "orderNumber", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "orderDate", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "orderedBy", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "poRefNumber", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "amount", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "id", _descriptor6, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "url", _descriptor7, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    _this.state = {
      isReorder: false
    };
    return _this;
  }

  babelHelpers.createClass(OrderLine, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "card"
      }, _react.default.createElement("div", {
        className: "card product"
      }, _react.default.createElement("a", {
        href: "javascript:void(0)",
        className: "top order-number",
        onClick: this.showOrder
      }, _react.default.createElement("h3", null, this.orderNumber)), _react.default.createElement("a", {
        href: "javascript:void(0)",
        className: "middle without-bottom",
        onClick: this.showOrder
      }, _react.default.createElement("div", {
        className: "inner-content"
      }, _react.default.createElement("h3", null, new Date(this.orderDate * 1000).format('F j, Y')), _react.default.createElement("p", null, this.poRefNumber ? "PO ".concat(this.poRefNumber, " - ") : '', "Ordered by ", this.orderedBy))), _react.default.createElement("div", {
        className: "bottom"
      }, _react.default.createElement("div", {
        className: "quantity"
      }, _react.default.createElement("p", null, this.formatPrice(this.amount))), _react.default.createElement("div", {
        className: "price"
      }, _react.default.createElement("a", {
        href: "javascript:void(0)",
        onClick: this.showOrder,
        className: "btn btn-default"
      }, "View")), _react.default.createElement("div", {
        className: "total"
      }, _react.default.createElement("a", {
        href: "javascript:void(0)",
        onClick: this.reOrder,
        "data-spin": this.state.isReorder ? 'true' : void 0,
        className: _classList.default.join('btn btn-default', this.state.isReorder ? 'spinning' : '')
      }, "Re-Order")))));
    }
  }, {
    key: "formatPrice",
    value: function formatPrice(amount) {
      amount = Number(amount).toFixed(2);
      var x = amount.split('.');
      var whole = x[0],
          dec = x[1];
      var dd = '';

      while (whole.length > 3) {
        dd = ",".concat(whole.substr(-3)).concat(dd);
        whole = whole.substring(0, whole.length - 3);
      }

      dd = whole + dd;
      return "$".concat(dd, ".").concat(dec);
    }
  }, {
    key: "showOrder",
    value: function showOrder() {
      require('layouts/SiteLayout').default.current.navigate(this.url);
    }
  }, {
    key: "reOrder",
    value: function reOrder() {
      var _this2 = this;

      if (this.state.isReorder) {
        return;
      }

      this.setState({
        isReorder: true
      }, function () {
        (0, _fetch.default)('data/cart/reorder', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            order: _this2.id
          })
        }).then(function (d) {
          return d.json();
        }).then(function (d) {
          require('layouts/SiteLayout').default.current.navigate(d.target);
        });
      });
    }
  }]);
  return OrderLine;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "orderNumber", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "orderDate", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "orderedBy", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "poRefNumber", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "amount", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "id", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "url", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class.prototype, "showOrder", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "showOrder"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "reOrder", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "reOrder"), _class.prototype)), _class);

function serverShow(page, orderList) {
  return "\n\t\t<div class='inner-content container'>".concat(require('react-dom/server').renderToString(_react.default.createElement(OrderHistory, {
    orderList: orderList
  })), "</div>\n\t\t").concat(page.inlineScriptArgs(function (orderList) {
    require('Orders').clientShow(this.querySelector('.inner-content'), orderList);
  }, orderList), "\n\t");
}

function clientShow(element, orderList) {
  _reactDom.default.render(_react.default.createElement(OrderHistory, {
    orderList: orderList
  }), element);
}